export const TRAINER_SET_ERROR = 'TRAINER_SET_ERROR';
export const TRAINER_RESET = 'TRAINER_RESET';
export const TRAINER_RESET_ERROR = 'TRAINER_RESET_ERROR';
export const TRAINER_SET_LOADING = 'TRAINER_SET_LOADING';
export const TRAINER_SET_ITEMS = 'TRAINER_SET_ITEMS';
export const TRAINER_SET_ITEM = 'TRAINER_SET_ITEM';
export const TRAINER_SET_OWN_TRAINER = 'TRAINER_SET_OWN_TRAINER';
export const TRAINER_PATCH_OWN_TRAINER_BALLS = 'TRAINER_PATCH_OWN_TRAINER_BALLS';
export const TRAINER_SET_PVP_MATCHES = 'TRAINER_SET_PVP_MATCHES';
export const TRAINER_SET_PVP_RANKED_LIST = 'TRAINER_SET_PVP_RANKED_LIST';
export const TRAINER_SET_INFO_MESSAGES = 'TRAINER_SET_INFO_MESSAGES';
export const USER_SET_LOADING = 'USER_SET_LOADING';
export const USER_SET_USER = 'USER_SET_USER';

